module.exports = __webpack_public_path__ + "img/certificate9.595b14c4.png";